<template>
	<span
		v-if="isDisplayPlaceholders"
		class="d-flex flex-row justify-content-end font-roboto"
	>
		<PlaceholderBox :height="'20px'" :width="'250px'" />
	</span>
	<span v-else>
		<span
			v-if="quantity > 0 && text"
			class="font-weight-700 font-size-16 text-primary-orange"
		>
			{{ text }}
		</span>
	</span>
</template>

<script> 
import { mapState } from "vuex";
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "LimitedAvailabilityMessage",
	props: {
		quantity: {
			type: Number,
			default: 0,
		},
		maxQuantity: {
			type: Number,
			default: 2,
		},
		isDisplayPlaceholders: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		PlaceholderBox,
	},
	computed: {
		...mapState(["content"]),
		text() {
			if (this.quantity > this.maxQuantity) return;
			const startText = this.content.planner_prestationsOnlyLeft;
			const endText = this.content.planner_prestationsAvailable;
			return `${startText} ${this.quantity} ${endText}`;
		},
	},
};
</script>

<style scoped></style>
